import React from 'react';
import './ErrorComponent.css';

const ErrorComponent = ({ error, onRetry }) => {
  let errorTitle = 'Error Loading Data';
  let errorMessage = error;
  let errorIcon = '⚠️';

  // Custom error messages based on error type
  if (error.includes('Failed to fetch rating data')) {
    errorTitle = 'Rating Data Unavailable';
    errorMessage = 'We couldn\'t retrieve the rating information for this location.';
    errorIcon = '📊';
  } else if (error.includes('Failed to fetch amenities data')) {
    errorTitle = 'Amenities Data Unavailable';
    errorMessage = 'We couldn\'t retrieve the amenities information for this location.';
    errorIcon = '🏪';
  } else if (error.includes('Comparison failed')) {
    errorTitle = 'Comparison Error';
    errorMessage = 'We couldn\'t complete the comparison. Please check the street name and try again.';
    errorIcon = '🔍';
  } else if (error.includes('No Data Available')) {
    errorTitle = 'No Data Found';
    errorMessage = 'We couldn\'t find any data for this location.';
    errorIcon = '📭';
  }

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-icon">{errorIcon}</div>
        <h3 className="error-title">{errorTitle}</h3>
        <p className="error-message">{errorMessage}</p>
        <div className="error-actions">
          <button onClick={() => window.location.href = '/'} className="error-home-button">
            Back to Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;